<template>
  <transition name="Fade" v-bind="$attrs" v-on="hooks">
    <slot></slot>
  </transition>
</template>

<script>
export default {
  name: "Fade",
  props: {
    duration: {
      type: Number,
      default: 600
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.setTiming,
        afterEnter: this.cleanUpTiming,
        beforeLeave: this.setTiming,
        afterLeave: this.cleanUpTiming,
        ...this.$listeners
      };
    }
  },
  methods: {
    setTiming(el) {
      el.style.transitionDuration = `${this.duration}ms`;
      el.style.transitionDelay = `${this.delay}ms`;
    },
    cleanUpTiming(el) {
      el.style.transitionDuration = "";
      el.style.transitionDelay = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.Fade-enter-active,
.Fade-leave-active {
  transition: opacity 0.6s ease-in-out 0.75s;
}

.Fade-enter,
.Fade-leave-to {
  opacity: 0;
}
</style>
